/* eslint-disable */
export default {
  unknown: 'Desconhecido',
  anonymous: 'Anônimo',
  activeCalls: 'Todas as chamadas',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCalls"@#@ @source: @#@"All Calls"@#@
